import { Box, Typography } from '@mui/material';
import zeplinColor from '../../../../../../theme/Color';
import CustomButton from '../../../../../shared/CustomButton/CustomButton';

interface ConnectOnboardingProps {
  onClose: () => void;
}

export const ConnectOnboarding = ({ onClose }: ConnectOnboardingProps) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '70%',
        left: '40%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1000,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box
        sx={{
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: zeplinColor.BasicBlack,
          borderRadius: '8px',
          gap: '16px',
          width: '380px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <img src={'assets/slack-connected.svg'} width={'40px'} height={'40px'} alt='icon' />
          <img
            src={'/assets/cross-white.svg'}
            alt='close'
            width={'24px'}
            height={'24px'}
            onClick={onClose}
            style={{ cursor: 'pointer' }}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
          <Typography variant='responsiveHeading3' color={zeplinColor.Neutral1}>
            Connect Calendar
          </Typography>
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
            Connect your preferred calendar (Zoom, Google Meet, Microsoft Teams, etc.) to view and
            manage upcoming meetings.
          </Typography>
        </Box>
        <CustomButton
          variant='outlined'
          style={{
            color: zeplinColor.Neutral1,
            borderRadius: '8px',
            backgroundColor: zeplinColor.Brand1,
            width: 'fit-content',
            height: '32px',
          }}
          text={'Okay'}
          onClick={onClose}
          disabled={false}
        />
      </Box>
    </Box>
  );
};
